const DEFAULT_SNS_TYPE = "instagram";

/**
 * SNS別のSCORE説明文定義。
 * 新規SNS追加時はここにエントリを追加する。
 */
const SCORE_DESCRIPTIONS = {
  instagram: {
    metricLabel: "リール視聴率中央値",
    calculationFactors: "PR率、平均EGR、直近90日のフォロワー増加率",
  },
  tiktok: {
    metricLabel: "視聴率中央値",
    calculationFactors: "PR率、平均EGR、直近90日のフォロワー増加率",
  },
  // youtube: { metricLabel: "...", calculationFactors: "..." },
  // twitter: { metricLabel: "...", calculationFactors: "..." },
};

export function getScoreDescription(snsType) {
  return SCORE_DESCRIPTIONS[snsType] || SCORE_DESCRIPTIONS[DEFAULT_SNS_TYPE];
}

export function getScoreDetailTooltip(snsType) {
  const description = getScoreDescription(snsType);
  if (description.detailTooltip) {
    return description.detailTooltip;
  }
  return `商材の広告効果/パフォーマンスを示すスコアです。<br />${description.calculationFactors}、${description.metricLabel}から算出しています。`;
}

export function getScoreListTooltip(snsType) {
  const description = getScoreDescription(snsType);
  if (description.listTooltip) {
    return description.listTooltip;
  }
  return `同性向け商材の広告効果/パフォーマンスを示すSCOREです。\n${description.calculationFactors}、${description.metricLabel}から算出しています。`;
}
